const csvTemplate = {
  rows: [
    ['(555) 555-1234'],
    ['(123) 456-7890'],
    ['(415) 555-5678'],
    ['(212) 555-1212'],
    ['(786) 555-9012'],
    ['1-800-555-1234'],
  ],

  templateName: 'Phone Number list Template',
};

export const PhoneNumberConfig = {
  csvTemplate,
};
